import Button from "../ui_components/button/button";
import {
    Modal,
    ModalActions as ModalActionsE,
    ModalContent,
    ModalHeader as ModalHeaderE,
    ModalProps,
} from "../ui_components/modal";
import PageDimmer from "../ui_components/dimmer/PageDimmer";
import React from "react";
import styled, { css } from "styled-components";
import { breakpoints, theme } from "../theme";
import PopupImg from "../assets/images/popup.png";

const noop = () => {
    /* ignore */
};

export interface WarningModalProps
    extends Pick<
        ModalProps,
        | "uiActive"
        | "uiOnRequestClose"
        | "className"
        | "uiOnClose"
        | "uiTransitionTimeout"
        | "uiCloseOnEsc"
        | "uiCloseOnOutsideClick"
    > {
    /**
     * Modal header
     */
    uiHeader?: string;
    /**
     * Accept button label
     */
    uiAcceptLabel?: string | false;
    /**
     * Close modal when pressing Esc
     * @default true
     */
    uiCloseOnEsc?: boolean;
    /**
     * Close modal on outside click
     * @default true
     */
    uiCloseOnOutsideClick?: boolean;
    /**
     * Class name
     */
    className?: string;
    /**
     * Child
     */
    children?: React.ReactNode;
    /**
     * Confirmation callback
     */
    uiOnConfirm(res?: unknown): void;

    /**
     * Edit Work Order condition
     */
    workOrderEditMode?: boolean;

    /**
     * Cancel editing Work Order
     */
    cancelEditing?(): void;
}

const WarningContent = styled(ModalContent)`
    display: flex;
    flex-flow: row wrap;
    align-items: center;
    color: ${theme.colors.grayRGBA};
`;

const StyledModal = styled(Modal)`
    max-width: 500px;
    border-radius: 0.5rem;
    border: solid ${theme.colors.grayRGBA} 1px;
    ${breakpoints.down(
        "sm",
        css`
            max-width: 90%;
        `
    )};
`;

const ModalHeader = styled(ModalHeaderE)`
    color: ${theme.colors.primary};
    border-bottom: none;
    padding-bottom: 0.25rem;
`;

const ModalHeaderDivider = styled.div`
    height: 10px;
    width: calc(100% - 40px);
    margin: 0 auto;
    background: ${theme.colors.divider};
`;

const ModalActions = styled(ModalActionsE)`
    border-bottom-left-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
    justify-content: flex-end;
    padding: 0.7rem 1rem;
`;

const BasicButton = styled(Button)`
    // width: 130px;
    box-shadow: none;
    border: 1px solid #c6c6c6;
    border-radius: 0.5em;
    display: block;
`;

const ConfirmButton = styled(BasicButton)`
    border-radius: 5px;
    // width: 100px;
    box-shadow: none;
    line-height: 0.6rem;
    &:hover {
        background: #c6c6c6;
    }
    margin-left: ${(props) =>
        props.className === "pop-up" ? "auto" : "initial"};
`;

/**
 * Simple confirmation modal
 */
export const WarningModal: React.FC<WarningModalProps> = (props) => {
    const rightButtonAction = props.workOrderEditMode ? props.uiOnRequestClose : props.uiOnRequestClose
    return (
        <StyledModal
            className={props.className}
            uiActive={props.uiActive}
            uiOnRequestClose={noop}
            uiDefaultSizes={false}
            uiOnClose={props.uiOnClose}
            uiTransitionTimeout={props.uiTransitionTimeout}
            uiCloseOnOutsideClick={props.uiCloseOnOutsideClick}
            uiCloseOnEsc={props.uiCloseOnEsc}
        >
            {props.uiAcceptLabel === "Setup" &&
                props.uiHeader === "Setup Needed" && <PageDimmer uiActive />}
            <ModalHeader><img style={{ marginRight: '10px', height:'30px' }} src={PopupImg} alt="" /> {props.uiHeader}</ModalHeader>
            <ModalHeaderDivider />
            <WarningContent>{props.children}</WarningContent>
            <ModalActions>
                {props.uiAcceptLabel && (
                    <ConfirmButton
                        id="confirm"
                        uiColor="primary"
                        onClick={rightButtonAction}
                        className={props.className}
                    >
                        {props.uiAcceptLabel}
                    </ConfirmButton>
                )}
            </ModalActions>
        </StyledModal>
    );
};

WarningModal.defaultProps = {
    uiHeader: "Warning!",
    uiAcceptLabel: "Close",
};
